module.exports = __webpack_public_path__ + "static/img/2.5e7c719.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home-en/2.png
// module id = 1cIH
// module chunks = 0